import React from 'react';
import { motion } from 'framer-motion';
import { useTranslation } from 'react-i18next';
import Navbar from '../components/Navbar';
import { FileText, User, Package, CreditCard, Scale } from 'lucide-react';

const DistanceSales = () => {
  const { t } = useTranslation();

  return (
    <div className="min-h-screen bg-background">
      <Navbar />
      <div className="max-w-4xl mx-auto px-4 py-12">
        <motion.div
          initial={{ opacity: 0, y: 20 }}
          animate={{ opacity: 1, y: 0 }}
        >
          <h1 className="font-heading text-4xl mb-2">
            {t('legal.distanceSales.title', 'Mesafeli Satis Sozlesmesi')}
          </h1>
          <p className="text-muted-foreground mb-8">
            {t('legal.distanceSales.lastUpdate', 'Son guncelleme: 26 Mart 2026')}
          </p>

          <div className="space-y-8 text-foreground/90 leading-relaxed">

            <section>
              <div className="flex items-center gap-3 mb-4">
                <div className="w-10 h-10 bg-primary/10 rounded-lg flex items-center justify-center">
                  <User className="w-5 h-5 text-primary" />
                </div>
                <h2 className="font-heading text-2xl">
                  {t('legal.distanceSales.seller.title', '1. Satici Bilgileri')}
                </h2>
              </div>
              <div className="pl-13 space-y-2">
                <table className="w-full text-sm">
                  <tbody className="divide-y divide-border">
                    <tr><td className="py-2 font-medium w-40">{t('legal.distanceSales.seller.company', 'Unvan')}</td><td className="py-2 text-muted-foreground">CerebrAI-VortX Neurotechnology</td></tr>
                    <tr><td className="py-2 font-medium">{t('legal.distanceSales.seller.address', 'Adres')}</td><td className="py-2 text-muted-foreground">Turkiye</td></tr>
                    <tr><td className="py-2 font-medium">E-posta</td><td className="py-2 text-muted-foreground">info@ink-track.com</td></tr>
                    <tr><td className="py-2 font-medium">Web</td><td className="py-2 text-muted-foreground">https://ink-track.com</td></tr>
                  </tbody>
                </table>
              </div>
            </section>

            <section>
              <div className="flex items-center gap-3 mb-4">
                <div className="w-10 h-10 bg-primary/10 rounded-lg flex items-center justify-center">
                  <Package className="w-5 h-5 text-primary" />
                </div>
                <h2 className="font-heading text-2xl">
                  {t('legal.distanceSales.product.title', '2. Hizmet Tanimi')}
                </h2>
              </div>
              <div className="pl-13 space-y-3">
                <p>{t('legal.distanceSales.product.p1', 'InkTrack, dovme bakim takibi, koleksiyon yonetimi ve sanatci rehberi hizmetleri sunan dijital bir platformdur.')}</p>
                <p><strong>{t('legal.distanceSales.product.free', 'Ucretsiz Plan:')}</strong> {t('legal.distanceSales.product.freeDesc', '3 dovme kaydi, temel bakim hatirlaticilari.')}</p>
                <p><strong>{t('legal.distanceSales.product.premium', 'Premium Plan (Aylik):')}</strong> $4.99/ay - {t('legal.distanceSales.product.premiumDesc', 'Sinirsiz dovme kaydi, AI analiz, vucut haritasi, sanatci rehberi.')}</p>
                <p><strong>{t('legal.distanceSales.product.yearly', 'Premium Plan (Yillik):')}</strong> $39.99/{t('legal.distanceSales.product.year', 'yil')} - {t('legal.distanceSales.product.yearlyDesc', 'Tum premium ozellikler, 2 ay ucretsiz, AR onizleme.')}</p>
              </div>
            </section>

            <section>
              <div className="flex items-center gap-3 mb-4">
                <div className="w-10 h-10 bg-primary/10 rounded-lg flex items-center justify-center">
                  <CreditCard className="w-5 h-5 text-primary" />
                </div>
                <h2 className="font-heading text-2xl">
                  {t('legal.distanceSales.payment.title', '3. Odeme Bilgileri')}
                </h2>
              </div>
              <div className="pl-13 space-y-3">
                <p>{t('legal.distanceSales.payment.p1', 'Odemeler iyzico altyapisi uzerinden guvenli sekilde alinmaktadir.')}</p>
                <p>{t('legal.distanceSales.payment.p2', 'Kabul edilen odeme yontemleri: Visa, MasterCard, Troy kredi/banka kartlari.')}</p>
                <p>{t('legal.distanceSales.payment.p3', 'Abonelikler otomatik olarak yenilenir. Yenileme oncesi bildirim gonderilir.')}</p>
                <p>{t('legal.distanceSales.payment.p4', 'Tum fiyatlar ABD Dolari (USD) cinsindendir. KDV dahildir.')}</p>
              </div>
            </section>

            <section>
              <div className="flex items-center gap-3 mb-4">
                <div className="w-10 h-10 bg-primary/10 rounded-lg flex items-center justify-center">
                  <Scale className="w-5 h-5 text-primary" />
                </div>
                <h2 className="font-heading text-2xl">
                  {t('legal.distanceSales.rights.title', '4. Cayma Hakki')}
                </h2>
              </div>
              <div className="pl-13 space-y-3">
                <p>{t('legal.distanceSales.rights.p1', '6502 sayili Tuketicinin Korunmasi Hakkinda Kanun ve Mesafeli Sozlesmeler Yonetmeligi uyarinca:')}</p>
                <ul className="list-disc list-inside space-y-2 text-muted-foreground">
                  <li>{t('legal.distanceSales.rights.li1', 'Tuketici, hizmetin satin alinmasindan itibaren 14 gun icinde herhangi bir gerekce gostermeksizin cayma hakkini kullanabilir.')}</li>
                  <li>{t('legal.distanceSales.rights.li2', 'Cayma hakki kullanildiginda odenen bedel 14 gun icinde iade edilir.')}</li>
                  <li>{t('legal.distanceSales.rights.li3', 'Dijital icerik teslimi basladiktan sonra cayma hakki kullanilamaz (tuketicinin onceden onay verdigi durumlarda).')}</li>
                </ul>
              </div>
            </section>

            <section>
              <div className="flex items-center gap-3 mb-4">
                <div className="w-10 h-10 bg-primary/10 rounded-lg flex items-center justify-center">
                  <FileText className="w-5 h-5 text-primary" />
                </div>
                <h2 className="font-heading text-2xl">
                  {t('legal.distanceSales.dispute.title', '5. Uyusmazlik Cozumu')}
                </h2>
              </div>
              <div className="pl-13 space-y-3">
                <p>{t('legal.distanceSales.dispute.p1', 'Bu sozlesme Turkiye Cumhuriyeti kanunlarina tabidir.')}</p>
                <p>{t('legal.distanceSales.dispute.p2', 'Uyusmazlik halinde Tuketici Hakem Heyetleri ve Tuketici Mahkemeleri yetkilidir.')}</p>
                <p>{t('legal.distanceSales.dispute.p3', 'Sikayet ve onerileriniz icin: info@ink-track.com')}</p>
              </div>
            </section>
          </div>
        </motion.div>
      </div>
    </div>
  );
};

export default DistanceSales;
